import { render, staticRenderFns } from "./TambahDokumentasi.vue?vue&type=template&id=27542290"
import script from "./TambahDokumentasi.vue?vue&type=script&lang=js"
export * from "./TambahDokumentasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports